export default __webpack_public_path__ + "static/P_SearchThumb_IN-6014HD-bf14c95a0b8d5b130ec77e4901304bf6.webp";